export default "__VITE_ASSET__Cl6O0z0g__"